<template>
  <div :class="['card', border ? 'card-border' : 'card-shadow']">
    <div class="card-tips" v-if="tips">
      <p>{{ tips }}</p>
    </div>
    <div class="card-wrapper" @click="cardClick">
      <div class="card-header" @click="toggleChecked">
        <img v-show="!isCheck && isRadio" :src="Circle" alt="circle">
        <img v-show="isCheck && isRadio" :src="Done_Circle" alt="circle">
        <h3>{{ title }}</h3>
      </div>
      <div class="card-content">
        <div class="card-status" v-if="status">
          <p :style="statusStyle" v-text="status" />
        </div>
        <div :class="status ? 'card-data-status' : 'card-data'">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Circle, Done_Circle } from '@/images'
export default {
  props: {
    isRadio: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    statusColor: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Circle,
      Done_Circle,
      isCheck: false
    }
  },
  computed: {
    statusStyle () {
      return {
        backgroundColor: this.statusColor
      }
    }
  },
  watch: {
    checked (newVal) {
      this.isCheck = newVal
    }
  },
  methods: {
    toggleChecked () {
      this.isCheck = !this.isCheck
      this.$emit('checkedChange', {
        checked: this.isCheck
      })
    },
    cardClick () {
      this.$emit('cardClick')
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  font-size: $span-font-size;
  line-height: 20px;
}
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 345px;
  margin-top: 15px;
  border-radius: 4px;
  overflow: hidden;
  background-color: $color-bg-white;
  .card-tips {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 330px;
    height: 37px;
    padding-left: 15px;
    background-color: $color-stage2;
    p {
      color: $color-text;
      font-size: $little-font-size;
      line-height: 17px;
    }
  }
  .card-wrapper {
    width: 315px;
    padding: 12px 0;
    .card-header {
      display: flex;
      flex-direction: row;
      padding-bottom: 12px;
      @include border-bottom;
      img {
        width: 20px;
        height: 20px;
        margin-top: 1px;
        margin-right: 17px;
      }
      h3 {
        max-width: 315px;
        overflow: hidden;
        color: $color-text;
        font-size: $base-font-size;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
        @include font-Medium;
      }
    }
    .card-content {
      .card-status {
        display: flex;
        flex-direction: row;
        margin-top: 12px;
        p {
          padding: 6px 16px;
          border-radius: 4px;
          color: $color-bg-white;
          font-size: $h3-font-size;
          line-height: 24px;
          direction: flex;
          transform: scale(0.5);
          transform-origin: left top;
        }
      }
    }
    .card-data-status {
      margin-top: -14px;
    }
    .card-data {
      margin-top: 4px;
    }
  }
}
.card-border {
  @include border-all(4px);

  box-shadow: 0 1px 5px 0 rgba(5, 47, 109, 0.05);
}
.card-shadow {
  box-shadow: 0 1px 5px 0 rgba(5, 47, 109, 0.05);
}
</style>
